import { Box } from '@mui/material';
import Resources from '../apps/home/Resources';
import IkhalaCalculators from '../apps/home/IkhalaCalculators';
import Infographic from '../apps/home/Infographic';
import BannerHeader from '../apps/rofburns/shared-components/BannerHeader';

export default function ResourcesPage() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <BannerHeader >
                Resources
            </BannerHeader>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, px: 3 }}>
                <Infographic />
                <Resources />
                <IkhalaCalculators />
            </Box>
        </Box>
    );
}